import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { appLayoutRoute } from '@/app/routes/roots';
import { validateListSearch } from '@/shared/lib/listSearch';

export const dealsRoute = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/deals',
  component: lazyRouteComponent(() => import('./pages/DealsPage'), 'DealsPage'),
  validateSearch: validateListSearch,
});

export const dealsRoutes = [dealsRoute];
